import { render, staticRenderFns } from "./Template354.vue?vue&type=template&id=4836ed5b&scoped=true&"
import script from "./Template354.vue?vue&type=script&lang=js&"
export * from "./Template354.vue?vue&type=script&lang=js&"
import style0 from "./Template354.vue?vue&type=style&index=0&id=4836ed5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836ed5b",
  null
  
)

export default component.exports